import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component.registration';
import { PasswordInfoComponent } from './uicomponents/password-info.component';
import { CodeInputComponent } from './uicomponents/code-input.component';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

const maskConfig: Partial<IConfig> = {
    validation: false,
};

@NgModule({
    imports: [BrowserModule, FormsModule, AutocompleteLibModule, NgxMaskModule.forRoot(maskConfig),
        ReactiveFormsModule,
        // ngx-translate and the loader module
        HttpClientModule,
        RecaptchaModule,  //this is the recaptcha main module
        RecaptchaFormsModule, //this is the module for form incase form validation
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [AppComponent, PasswordInfoComponent, CodeInputComponent],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    //return new TranslateHttpLoader(http, '../../../../../assets/i18n_2/');
    return new TranslateHttpLoader(http);
}